import React, { useEffect, useState } from 'react'
import InputAdornment from '@material-ui/core/InputAdornment'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'
import { get } from '../data/api'
import Button from '../generic/Button'
import Input from '@material-ui/core/Input'
import assignClientToUser from './assignClientToUser.js'

export default function MyUser(props) {
	const { userId, userName, userEmail } = props
	const [searchTerm, setSearchTerm] = useState('')
	const [resultClients, setResultClients] = useState(null)
	const [isLoading, setIsLoading] = useState(false)

	function handleKeyDown(event) {
		setSearchTerm(event.target.value)
	}

	const fetchClientByName = async () => {
		if (searchTerm.length) {
			const clients = await get(`/hubs/by-name/${searchTerm}`, 'GET')

			if (clients.length === 1) {
				await switchClient(clients[0].client_id)
				return
			}

			setResultClients(clients)
		}
	}

  const switchClient = async (newClientId) => {
    setIsLoading(true)
    await assignClientToUser(userId, newClientId)
    setIsLoading(false)
    window.location.reload()
  }	
  
  return (
		<div className='user'>
			<h4>
				{userName}
				<small style={{ marginLeft: '5px' }}>
					(<span>{userEmail}</span>)
				</small>
			</h4>
			<div className='search'>
				<Input
					className='input'
					id='adornment-password'
					type='text'
					value={searchTerm}
					onChange={handleKeyDown}
					onKeyDown={(e) => {
						if (e.key === 'Enter') {
							fetchClientByName()
						}
					}}
					endAdornment={
						<InputAdornment position='end'>
							<Button className='btn' onClick={fetchClientByName}>
								Search
							</Button>
						</InputAdornment>
					}
					autoFocus
				/>
			</div>
			{resultClients !== null && !isLoading ? (
				resultClients.length > 0 ? (
					<List>
						{resultClients.map((client, index) => (
							<ListItem
								button
								key={index}
								id={client.client_id}
								onClick={(e) => switchClient(e.currentTarget.id)}
							>
								<ListItemText primary={client.name} />
							</ListItem>
						))}
					</List>
				) : (
					<p className='no-results'>Nothing is found</p>
				)
			) : null}
			{isLoading ? <h3 style={{ marginTop: '20px', color: 'blue' }}>Loading...</h3> : null}
		</div>
	)
}
